var _path, _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdapt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 60,
    viewBox: "0 0 63 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0H33C49.5685 0 63 13.4315 63 30C63 46.5685 49.5685 60 33 60H30C13.4315 60 0 46.5685 0 30Z",
    fill: "#65D3E9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.2
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 5.5,
    width: 54,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 5.5,
    width: 54,
    height: 49,
    rx: 24.5,
    stroke: "#FAFAFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4672_3094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5117 37.6966V28.9666C30.5117 26.2879 28.342 24.1166 25.6655 24.1166H23.1593L24.4124 25.3707L24.4298 25.3886C24.7908 25.7686 24.785 26.3696 24.4124 26.7425C24.0398 27.1154 23.4393 27.1212 23.0596 26.7599L23.0417 26.7425L20.134 23.8325C19.7555 23.4537 19.7555 22.8395 20.134 22.4607L23.0417 19.5507C23.4202 19.1719 24.0339 19.1719 24.4124 19.5507C24.7909 19.9295 24.7909 20.5437 24.4124 20.9225L23.1593 22.1766H25.6655C29.4126 22.1766 32.4501 25.2165 32.4501 28.9666V37.6966C32.4501 38.2323 32.0161 38.6666 31.4808 38.6666C30.9456 38.6666 30.5117 38.2323 30.5117 37.6966Z",
    fill: "#0B4F5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5498 37.6966V28.9666C30.5498 25.2165 33.5873 22.1766 37.3344 22.1766H39.8406L38.5875 20.9225L38.5701 20.9046C38.2091 20.5246 38.2149 19.9236 38.5875 19.5507C38.9601 19.1778 39.5606 19.172 39.9403 19.5333L39.9582 19.5507L42.8659 22.4607C43.2444 22.8395 43.2444 23.4537 42.8659 23.8325L39.9582 26.7425C39.5797 27.1213 38.966 27.1213 38.5875 26.7425C38.209 26.3637 38.209 25.7495 38.5875 25.3707L39.8406 24.1166H37.3344C34.6579 24.1166 32.4883 26.2879 32.4883 28.9666V37.6966C32.4883 38.2323 32.0543 38.6666 31.5191 38.6666C30.9838 38.6666 30.5498 38.2323 30.5498 37.6966Z",
    fill: "#0B4F5D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4672_3094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(11.5 9.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdapt);
export default __webpack_public_path__ + "static/media/adapt.5710cb4d249173819691518fde81fc00.svg";
export { ForwardRef as ReactComponent };